var _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4F7FA"
    },
    cx: 1871.379,
    cy: 1855,
    r: 1400
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2404.983,2514.899c-36.414-12.079-63.631-42.983-71.306-80.967l-52.999-262.31l-453.372,16.099 l-55.798,273.269c-7.814,38.271,23.467,76.666,59.494,90.761l189.681,74.215c35.28,13.803,73.202,19.301,110.894,16.077 l400.865-34.293c11.718-1.002,21.118-10.214,22.482-22.032s9.574-25.086-1.601-28.793L2404.983,2514.899z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2165.8591,
    y1: 2264.9285,
    x2: 2172.7507,
    y2: 2523.3613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2409.469,2498.946c-36.377-11.926-63.566-42.442-71.233-79.949l-52.946-259.012 l-442.32,15.914l-55.741,269.833c-7.806,37.79,12.849,75.685,48.839,89.604l189.489,73.282 c35.244,13.63,73.128,19.059,110.782,15.875l400.46-33.862c11.706-0.99,21.097-10.086,22.459-21.754 c1.362-11.669-5.68-22.684-16.844-26.344L2409.469,2498.946z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179608693193744932320000014223107985757898127_",
    gradientUnits: "userSpaceOnUse",
    x1: 2222.1228,
    y1: 1943.6464,
    x2: 1462.7058,
    y2: -722.5026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179608693193744932320000014223107985757898127_)"
    },
    d: "M3133.462,1989.244V813.058 c0-24.118-19.877-44.65-44.235-45.629L1068.521,686.2c-30.749-1.237-55.983,20.011-55.983,47.222v1299.863L3133.462,1989.244z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057848709858537875940000009583094478284441472_",
    gradientUnits: "userSpaceOnUse",
    x1: 2660.0999,
    y1: 667.4018,
    x2: 1361.8792,
    y2: 2169.7927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057848709858537875940000009583094478284441472_)"
    },
    d: "M3045.65,826.177l-1919.693-71.618 c-27.972-1.043-50.92,18.412-50.92,43.237v116.527v1015.379c0,25.344,23.428,45.414,51.981,44.602l1917.779-54.54 c22.888-0.651,41.568-19.676,41.568-42.281V971.881V867.952C3086.366,845.811,3068.068,827.013,3045.65,826.177z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100371211597582126180000006650853904723065250_",
    gradientUnits: "userSpaceOnUse",
    x1: 1012.5373,
    y1: 2160.8708,
    x2: 3133.4624,
    y2: 2160.8708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100371211597582126180000006650853904723065250_)"
    },
    d: "M1012.537,2033.285v259.596 c0,27.21,25.234,48.405,55.983,47.105l2020.707-85.428c24.358-1.03,44.235-21.603,44.235-45.721v-227.137L1012.537,2033.285z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2914.596,1837.39c-165.964-56.056-303.268,58.284-422.564-31.743 c-134.493-101.496-25.787-296.482-150.194-411.352c-172.822-159.574-518.333,87.899-668.396-62.541 c-103.171-103.43,18.531-269.021-68.831-443.209c-44.42-88.566-127.654-148.946-228.69-189.989l-307.4-12.357 c-30.749-1.237-55.982,20.011-55.982,47.222v1299.863v259.596c0,27.21,25.233,48.405,55.982,47.105l2020.708-85.428 c24.359-1.03,44.236-21.603,44.236-45.721v-167.84C3062.301,1915.19,2983.745,1860.745,2914.596,1837.39z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000040557004473618304210000004035961995377608092_",
    d: "M1656.332,1928.151l-216.781,121.409 c0,0-103.087-88.349-93.915-196.582c18.714-220.826-175.999-221.804-257.491-234.414 c-122.897-19.017-222.905-89.373-120.724-201.613c102.181-112.24-133.117-236.239-336.021-238.346 c-198.556-2.061-309.465-356.206,120.695-391.204c256.89-20.9,346.274,213.816,419.591,321.615 c73.317,107.798,247.101,22.787,266.949,193.52c16.954,145.837-28.368,284.483,88.6,325.766 C1644.201,1669.585,1702.638,1756.593,1656.332,1928.151z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175289885421693209020000017787733037568676488_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040557004473618304210000004035961995377608092_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022544843334136803100000010973362669033853079_",
    gradientUnits: "userSpaceOnUse",
    x1: 1140.8197,
    y1: 1221.3721,
    x2: 814.657,
    y2: 2094.8259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000175289885421693209020000017787733037568676488_)",
      fill: "url(#SVGID_00000022544843334136803100000010973362669033853079_)"
    },
    d: " M1656.332,1928.151l-216.781,121.409c0,0-103.087-88.349-93.915-196.582c18.714-220.826-175.999-221.804-257.491-234.414 c-122.897-19.017-208.939-84.33-137.575-197.924c80.745-128.526-116.266-239.927-319.17-242.034 c-198.556-2.061-309.465-356.206,120.695-391.204c256.89-20.9,346.274,213.816,419.591,321.615 c73.317,107.798,247.101,22.787,266.949,193.52c16.954,145.837-28.368,284.483,88.6,325.766 C1644.201,1669.585,1702.638,1756.593,1656.332,1928.151z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000175289885421693209020000017787733037568676488_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1573.777,2000.817l-4.964,1.696c-1.05-3.074-107.325-310.489-304.571-583.474 c-181.714-251.494-480.072-524.374-869.508-396.186l-1.641-4.982c173.358-57.065,343.384-40.773,505.355,48.419 c129.387,71.249,253.91,188.926,370.108,349.762C1466.235,1689.672,1572.723,1997.736,1573.777,2000.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M964.522,1106.484l-4.86,1.977C893.827,946.769,715.993,764.31,714.205,762.485l3.744-3.673 C719.745,760.645,898.301,943.845,964.522,1106.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M854.972,1050.013c-207.813-9.703-325.955,116.963-327.123,118.243l-3.874-3.534 c1.184-1.302,120.881-129.77,331.241-119.949L854.972,1050.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1383.471,1604.532c-172.01-187.109-495.105-75.674-498.162-74.325l-2.425-4.645 c2.875-1.608,330.911-113.35,504.447,75.421L1383.471,1604.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1333.679,1512.313l-5.005,1.577c-48.774-154.675,48.115-334.163,49.101-335.959l4.599,2.521 C1381.399,1182.231,1285.582,1359.798,1333.679,1512.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1551.025,1954.506c-53.633-80.285-210.776-79.631-212.357-79.617l-0.053-5.243 c6.569-0.069,161.557-0.708,216.771,81.947L1551.025,1954.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1526.837,1881.369l-4.943,1.756c-25.561-71.935,32.72-200.657,51.872-242.956 c2.706-5.978,5.042-11.138,5.277-12.139l5.123,1.127c-0.312,1.417-1.855,4.852-5.622,13.176 C1559.608,1684.155,1501.984,1811.427,1526.837,1881.369z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095322788280720895460000007616459921407490958_",
    gradientUnits: "userSpaceOnUse",
    x1: 2745.0662,
    y1: 1282.8853,
    x2: 3466.1052,
    y2: 2469.9014,
    gradientTransform: "matrix(0.9571 -0.2896 0.2896 0.9571 -2114.9714 1066.7954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095322788280720895460000007616459921407490958_)"
    },
    d: "M1633.597,2399.298 c1.339,0.164,2.68,0.322,4.023,0.477c79.441,9.176,167.881,5.172,265.166-19.962c18.618-6.237,37.236-12.474,55.854-18.711 c2.451-49.345-4.051-96.715-66.47-97.008c-96.935-0.454-145.169-156.526-137.043-219.144 c10.056-77.504,29.768-258.45-120.078-261.509c-124.746-2.548-205.765,21.304-256.961-123.294 c-51.197-144.598-158.361-212.694-289.059-164.773c-137.538,50.431-307.427-102.439-403.965-6.217 c-168.21,167.664,108.376,438.169,379.436,460.399c271.059,22.23,157.19,151.026,185.979,273.214 c39.303,166.811,250.941,66.478,328.531,113.739C1605.291,2352.516,1622.425,2375.11,1633.597,2399.298z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000125593197298666497150000014349388941999198137_",
    d: "M1653.729,2491.674l304.873-92.245 c4.702-48.531,3.29-135.008-66.433-135.335c-96.935-0.455-145.169-156.525-137.043-219.145 c10.057-77.503,29.769-258.449-120.078-261.509c-124.746-2.548-205.765,21.305-256.961-123.293 c-51.197-144.598-158.361-212.695-289.058-164.773c-137.539,50.43-307.428-102.439-403.965-6.216 c-168.21,167.663,108.376,438.168,379.436,460.398c271.059,22.23,157.19,151.026,185.979,273.214 c39.303,166.812,250.94,66.478,328.531,113.739C1639.836,2373.557,1651.822,2445.835,1653.729,2491.674z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176043284843271122650000013091313507106344628_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125593197298666497150000014349388941999198137_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000176043284843271122650000013091313507106344628_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1782.771,2400.284l6.097-3.236c-236.68-445.669-688.496-774.287-1179.13-857.612l-1.155,6.805 C1097.149,1629.215,1547.073,1956.467,1782.771,2400.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1632.917,2168.357l6.616-1.969c-56.597-190.065,62-386.67,63.205-388.634l-5.883-3.609 C1695.633,1776.133,1575.43,1975.296,1632.917,2168.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1736.996,2319.487l4.886-4.874c-141.993-142.342-499.257-62.089-502.849-61.261l1.549,6.727 C1244.136,2259.26,1597.703,2179.852,1736.996,2319.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1275.378,1826.604l5.288-4.439c-102.592-122.122-75.319-365.17-75.032-367.611l-6.854-0.811 C1198.489,1456.214,1170.889,1702.225,1275.378,1826.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M997.907,1666.241l1.788-6.669c-175.551-47.018-390.383,71.807-392.535,73.017l3.377,6.021 C612.659,1737.413,825.091,1619.954,997.907,1666.241z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072983585763280260900000006990840790326582959_",
    gradientUnits: "userSpaceOnUse",
    x1: 1726.2158,
    y1: 2937.6362,
    x2: 1560.7952,
    y2: 3007.113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072983585763280260900000006990840790326582959_)"
    },
    d: "M3086.366,2847.118l-2354.815-20.509 v60.682c0,16.47,10.271,30.475,24.181,32.971l665.871,119.494c7.902,1.418,15.916,1.794,23.89,1.122l1615.283-136.243 c14.421-1.216,25.59-15.264,25.59-32.187V2847.118z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141441501023135643520000000800377037204603047_",
    gradientUnits: "userSpaceOnUse",
    x1: 1505.3285,
    y1: 2208.5718,
    x2: 1325.8044,
    y2: 2283.9719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141441501023135643520000000800377037204603047_)"
    },
    d: "M2328.321,2748.749L757.468,2859.76 c-28.109,1.986-50.964-19.121-50.964-47.151V1689.636c0-28.03,22.855-50.752,50.964-50.752h1570.853 c23.158,0,41.882,20.541,41.882,45.879V2699.91C2370.202,2725.248,2351.479,2747.112,2328.321,2748.749z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044859832515329067410000013713314942953682110_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.5506,
    y1: 2249.3865,
    x2: 2395.2498,
    y2: 2249.3865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044859832515329067410000013713314942953682110_)"
    },
    d: "M2353.368,2748.749L782.515,2859.76 c-28.11,1.986-50.965-19.121-50.965-47.151V1689.636c0-28.03,22.855-50.752,50.965-50.752h1570.853 c23.158,0,41.882,20.541,41.882,45.879V2699.91C2395.25,2725.248,2376.526,2747.112,2353.368,2748.749z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116211470877050427590000008243631423010475665_",
    gradientUnits: "userSpaceOnUse",
    x1: 2122.9946,
    y1: 1420.9847,
    x2: 770.9083,
    y2: 3310.4368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116211470877050427590000008243631423010475665_)"
    },
    d: "M2304.431,2677.179l-1463.085,96.428 c-22.875,1.507-41.464-15.817-41.464-38.699v-983.165c0-22.882,18.589-41.51,41.464-41.604l1463.085-6.055 c19.104-0.079,34.556,16.752,34.556,37.594v895.487C2338.988,2658.006,2323.535,2675.921,2304.431,2677.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1623.419,1669.599c0,10.434-8.085,18.917-18.069,18.948c-9.997,0.031-18.109-8.422-18.109-18.88 s8.112-18.941,18.109-18.949C1615.334,1650.711,1623.419,1659.164,1623.419,1669.599z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006694834762391837240000006846758466979746719_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.5506,
    y1: 2864.616,
    x2: 3086.3657,
    y2: 2864.616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006694834762391837240000006846758466979746719_)"
    },
    d: "M2314.172,2743.715l-1582.621,116.85 l690.052,123.833c7.902,1.418,15.916,1.794,23.89,1.122l1640.873-138.401l-747.019-102.609 C2330.993,2743.361,2322.567,2743.095,2314.172,2743.715z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101808415276157210940000003551190123595978168_",
    gradientUnits: "userSpaceOnUse",
    x1: 962.4796,
    y1: 2845.322,
    x2: 2687.8381,
    y2: 2845.322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000101808415276157210940000003551190123595978168_)"
    },
    points: "962.48,2863.503  2280.059,2764.772 2687.838,2820.333 1381.609,2925.871  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#FFFFFF"
    },
    d: "M1974.896,2440.756c-121.099-65.157-216.318,17.404-308.211-64.055 c-55.712-49.386-28.36-86.214-96.912-160.016c-75.927-81.742-125.359-54.264-201.664-127.833 c-96.483-93.022-48.228-165.395-131.336-232.182c-100.822-81.022-209.552-6.031-305.527-83.734 c-41.395-33.513-64.107-82.236-75.968-134.053H761.37c-16.456,0-29.819,13.337-29.819,29.79v1164.059 c0,16.453,13.363,28.842,29.819,27.674l1600.956-113.639c7.857-0.557,14.823-5.145,19.294-11.795 c-117.195-4.271-189.193-43.558-235.217-84.173C2056.369,2571.346,2071.986,2492.995,1974.896,2440.756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025406090962815022860000013372077056316369040_",
    gradientUnits: "userSpaceOnUse",
    x1: 3126.7927,
    y1: 2629.7549,
    x2: 2800.3562,
    y2: 2351.2896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025406090962815022860000013372077056316369040_)"
    },
    d: "M3043.653,2032.798v703.086 c0,10.514-8.971,12.9-19.13,13.374l-340.17,22.31l-5.036,0.232c-10.323,0.476-18.773-7.811-18.773-18.415v-709.119 c0-10.604,8.449-19.53,18.773-19.835l6.835-0.202l341.528,5.696C3037.844,2029.636,3043.653,2022.284,3043.653,2032.798z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075125887467402806560000017931686477121876382_",
    gradientUnits: "userSpaceOnUse",
    x1: -1000.692,
    y1: 4238.8896,
    x2: 245.0968,
    y2: 4285.2319,
    gradientTransform: "matrix(0 -1 1 0 -1389.0323 1734.3226)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075125887467402806560000017931686477121876382_)"
    },
    d: "M3054.529,2032.135v703.591 c0,10.522-8.321,19.514-18.496,19.983l-346.356,15.962c-10.337,0.477-18.799-7.816-18.799-18.428v-709.615 c0-10.612,8.461-19.544,18.799-19.849l346.356-10.227C3046.208,2013.25,3054.529,2021.613,3054.529,2032.135z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020383436023316419610000011739486390540402088_",
    gradientUnits: "userSpaceOnUse",
    x1: 2971.7463,
    y1: 2256.2273,
    x2: 2555.8994,
    y2: 2815.3621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020383436023316419610000011739486390540402088_)"
    },
    d: "M3043.038,2071.486v651.3 c0,9.816-7.765,18.202-17.259,18.637l-325.693,14.902c-9.637,0.441-17.524-7.294-17.524-17.189v-656.538 c0-9.895,7.888-18.231,17.524-18.524l325.693-9.91C3035.273,2053.875,3043.038,2061.67,3043.038,2071.486z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE8BDF"
    },
    d: "M2869.958,2039.785c0,3.662-2.881,6.718-6.436,6.825c-3.555,0.107-6.438-2.776-6.438-6.439 s2.882-6.719,6.438-6.825C2867.076,2033.24,2869.958,2036.123,2869.958,2039.785z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.48
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2942.034,2439.777c-31.578-79.386-116.693-60.634-143.209-140.868 c-21.643-65.49,26.499-103.867,7.652-179.693c-10.574-42.546-36.594-74.158-63.194-97.017l-52.738,1.555 c-10.629,0.313-19.343,9.246-19.343,19.849v709.015c0,10.603,8.714,18.363,19.343,17.248l265.294-27.832 c-21.292-33.565-29.846-64.235-32.867-89.705C2911.973,2559.636,2970.964,2512.508,2942.034,2439.777z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078016490646425629760000012341458765027742096_",
    gradientUnits: "userSpaceOnUse",
    x1: 2747.2039,
    y1: 964.459,
    x2: 2414.3953,
    y2: 1284.3431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078016490646425629760000012341458765027742096_)"
    },
    d: "M2083.147,2460.211 c-29.359,0.849-57.995-6.55-82.799-21.414c-75.571-45.302-187.236-120.114-287.698-218.044 c-127.476-124.269-200.719-250.588-216.744-374.629l-0.251-1.944l-3.11-529.279c0-104.602,68.226-189.51,196.318-245.304 c105.83-46.095,246.099-68.936,394.284-64.647c146.46,4.239,281.984,34.459,382.294,84.811 c119.24,59.857,181.804,143.975,181.804,243.705l-2.836,505.73l-0.23,1.859c-14.645,118.782-82.033,241.561-201.14,365.719 c-95.535,99.582-203.491,178.5-277.633,227.397C2140.878,2450.351,2112.439,2459.363,2083.147,2460.211z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091720502668234501200000017674183186364869251_",
    gradientUnits: "userSpaceOnUse",
    x1: 1758.0428,
    y1: 1037.3489,
    x2: 2889.3396,
    y2: 2887.6592
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091720502668234501200000017674183186364869251_)"
    },
    d: "M2112.213,2460.211 c-28.971,0.849-57.229-6.55-81.706-21.414c-74.573-45.302-184.763-120.114-283.897-218.044 c-125.792-124.269-198.067-250.588-213.879-374.629l-0.249-1.944l-3.069-529.279c0-104.602,67.324-189.51,193.724-245.304 c104.432-46.095,242.847-68.936,389.075-64.647c144.525,4.239,278.258,34.459,377.241,84.811 c117.667,59.857,179.403,143.975,179.403,243.705l-2.8,505.73l-0.227,1.859c-14.45,118.782-80.949,241.561-198.483,365.719 c-94.273,99.582-200.802,178.5-273.965,227.397C2169.18,2450.351,2141.117,2459.363,2112.213,2460.211z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078011207692871017130000004208023312902718343_",
    gradientUnits: "userSpaceOnUse",
    x1: 2357.9258,
    y1: 2090.842,
    x2: 1439.1486,
    y2: 243.3705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078011207692871017130000004208023312902718343_)"
    },
    d: "M1564.36,1315.281l3.089,526.605 c34.664,268.688,350.432,486.225,487.96,568.874c39.397,23.676,89.767,22.273,128.886-3.468 c134.657-88.607,433.13-311.677,465.021-570.009l2.833-504.336C2652.149,958.773,1564.36,924.565,1564.36,1315.281z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013157274925138724980000001749269300451263670_",
    gradientUnits: "userSpaceOnUse",
    x1: 1668.6288,
    y1: 1732.4355,
    x2: 2555.7568,
    y2: 1732.4355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013157274925138724980000001749269300451263670_)"
    },
    d: "M2120.016,2329.59 c-2.521,0.059-6.336-0.36-10.191-2.697c-56.626-34.291-166.395-106.117-261.89-199.917 c-103.148-101.322-162.639-199.832-176.281-292.352l-3.026-517.885c0.125-49.691,39.461-92.219,116.566-126.247 c86.075-37.989,208.313-57.923,334.823-54.918c125.248,2.973,243.919,28.187,326.133,68.983 c72.723,36.085,109.489,78.625,109.606,126.598l-2.82,499.954c-12.732,89.531-68.568,186.05-166.602,287.51 c-92.178,95.398-199.854,171.021-256.135,207.796C2126.349,2328.929,2122.537,2329.53,2120.016,2329.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2107.095,2294.191c-57.187-35.221-158.876-103.232-247.599-190.548 c-96.936-95.4-153.032-186.946-166.22-271.653l-3.003-514.878c0.089-35.528,32.747-68.118,96.818-96.486 c81.539-36.105,198.364-55.13,320-52.4c120.47,2.705,234.021,26.499,312.053,65.108c60.631,29.998,91.303,62.721,91.386,97.371 l-2.814,498.116c-12.373,82.185-65.285,172.067-157.812,267.653C2264.002,2185.221,2164.022,2256.582,2107.095,2294.191z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026159737562465046850000013416739355081735809_",
    gradientUnits: "userSpaceOnUse",
    x1: 2394.7612,
    y1: 1274.7335,
    x2: 2029.9005,
    y2: 1949.172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026159737562465046850000013416739355081735809_)"
    },
    d: "M2311.714,1620.076l-385.086,3.426 c-29.603,0.264-53.721,23.341-53.721,51.529v246.729c0,28.023,24.028,49.743,53.524,48.535l383.727-15.713 c27.294-1.117,49.428-23.712,49.568-50.486l1.219-235.7C2361.084,1641.474,2339.101,1619.833,2311.714,1620.076z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106124744488507667470000001554782371919840186_",
    gradientUnits: "userSpaceOnUse",
    x1: 2072.2441,
    y1: 1807.3551,
    x2: 2171.8625,
    y2: 1807.3551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106124744488507667470000001554782371919840186_)"
    },
    d: "M2171.862,1761.559 c0.086-27.25-23.302-48.79-51.86-46.984c-25.285,1.596-46.259,22.016-47.678,46.521c-1.1,19.007,9.18,35.474,24.83,43.832 c6.653,3.554,9.943,11.002,8.63,18.355l-11.129,62.328c-1.416,7.933,4.872,14.914,13.163,14.623l28.171-0.989 c8.236-0.288,14.502-7.669,13.141-15.466l-10.769-61.736c-1.286-7.372,2.513-14.68,9.19-18.695 C2162.066,1794.615,2171.806,1779.077,2171.862,1761.559z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083080843857095533210000005348303488863389620_",
    gradientUnits: "userSpaceOnUse",
    x1: 2289.3335,
    y1: 1217.6989,
    x2: 1924.4729,
    y2: 1892.1368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083080843857095533210000005348303488863389620_)"
    },
    d: "M2306.305,1595.604 c-11.565,0.075-20.917-9.112-20.867-20.525l0.234-53.745c0.236-53.98-44.39-98.386-100.008-98.938l-125.694-1.247 c-57.56-0.573-104.887,44.312-104.936,99.999l-0.049,55.444c-0.01,11.772-10.033,21.38-22.412,21.461 c-12.408,0.081-22.483-9.434-22.478-21.256l0.021-55.674c0.031-79.587,67.81-143.496,149.936-142.355l125.749,1.748 c78.998,1.098,142.102,64.324,141.733,140.843l-0.258,53.532C2327.223,1586.254,2317.843,1595.528,2306.305,1595.604z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052073177311404269200000015194411827531752373_",
    gradientUnits: "userSpaceOnUse",
    x1: -2300.1841,
    y1: 317.6514,
    x2: -2331.6228,
    y2: 534.4141,
    gradientTransform: "matrix(-0.8096 -0.587 -0.587 0.8096 188.4058 -458.3016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052073177311404269200000015194411827531752373_)"
    },
    d: "M1506.828,1864.245 c0,0,7.432-10.581,11.343-18.034c3.911-7.453-5.618-28.093-9.822-45.32c-4.203-17.228-6.367,9.645-6.897,15.729 c-0.531,6.086-0.594,17.328-6.89,36.628L1506.828,1864.245z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016770690264473682700000001724966212042208918_",
    gradientUnits: "userSpaceOnUse",
    x1: 926.5894,
    y1: 3209.1343,
    x2: 966.3373,
    y2: 3209.1343,
    gradientTransform: "matrix(0.9858 -0.1678 0.1678 0.9858 0.9801 -81.3323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016770690264473682700000001724966212042208918_)"
    },
    d: "M1459.082,2899.889l-2.888,46.188 c0,0,6.559,6.948,19.175,2.112l13.783-45.355L1459.082,2899.889z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135682008949850296500000007223206533424558246_",
    gradientUnits: "userSpaceOnUse",
    x1: 1003.4061,
    y1: 3045.3594,
    x2: 899.1778,
    y2: 3411.0422,
    gradientTransform: "matrix(0.9858 -0.1678 0.1678 0.9858 0.9801 -81.3323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135682008949850296500000007223206533424558246_)"
    },
    d: "M1464.864,2933.849 c0,0-22.621,9.227-18.23,19.231c2.358,5.372,10.517,17.507,17.568,27.593c6.526,9.335,18.314,13.467,29.225,10.198 c3.661-1.097,7.407-2.169,10.722-3.024c6.857-1.768,7.258-11.353,0.58-13.708c-3.239-1.141-6.446-2.065-9.239-2.496 c-8.282-1.278-19.676-20.842-21.01-28.679S1464.864,2933.849,1464.864,2933.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105417753020243652210000001826852214494813356_",
    gradientUnits: "userSpaceOnUse",
    x1: 1578.1101,
    y1: 2583.6948,
    x2: 1241.075,
    y2: 2860.5454
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105417753020243652210000001826852214494813356_)"
    },
    d: "M1410.491,2456.58 c33.319,11.498,156.532,58.073,183.976,164.901c1.465,5.703,5.223,21.562,5.393,47.466 c0.709,107.827-61.994,199.084-107.596,252.172c-14.377-0.24-28.754-0.48-43.13-0.721c-7.176-27.52-13.769-68.682-3.45-114.996 c15.771-70.786,56.686-89.146,48.796-123.89c-14.328-63.093-160.832-53.547-174.637-110.044 C1314.856,2551.06,1325.813,2516.428,1410.491,2456.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010276031948343687280000011547142811236437896_",
    gradientUnits: "userSpaceOnUse",
    x1: 1400.5016,
    y1: 2520.0798,
    x2: 1308.2665,
    y2: 2843.6848,
    gradientTransform: "matrix(0.9956 0.0937 -0.0937 0.9956 20.029 69.0563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010276031948343687280000011547142811236437896_)"
    },
    d: "M998.38,3102.128l62.563-1.459 c3.855-0.089,5.511-4.896,2.558-7.376c-2.91-2.445-6.933-4.446-12.073-3.911c-11.893,1.237-38.589-15.406-50.701-11.835 c-3.957,1.167-7.171,10.475-8.819,13.048C988.672,3095.647,992.381,3102.268,998.38,3102.128z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160886219761366844060000003464118449012201654_",
    gradientUnits: "userSpaceOnUse",
    x1: 1258.2789,
    y1: 2892.0701,
    x2: 1305.1757,
    y2: 2892.0701,
    gradientTransform: "matrix(0.9956 0.0937 -0.0937 0.9956 20.029 69.0563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160886219761366844060000003464118449012201654_)"
    },
    d: "M1026.488,3054.063l-25.762,23.483 c0,0,8.994,6.72,22.116,3.84l26.332-18.123L1026.488,3054.063z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162353071464940104120000000777341492079198871_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.4194,
    y1: 3151.1855,
    x2: 833.5284,
    y2: 2942.7234,
    gradientTransform: "matrix(0.9858 -0.1678 0.1678 0.9858 0.9801 -81.3323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162353071464940104120000000777341492079198871_)"
    },
    d: "M1521.022,2734.785 c17.28-46.654,38.002-104.178,14.336-136.84c-23.95-33.053-76.421-5.155-129.059-31.788 c-19.525-9.88-39.589-27.559-56.282-59.555c-29.551,30.507-33.565,50.983-30.172,64.866 c13.805,56.497,160.309,46.951,174.637,110.044c7.891,34.744-33.024,53.104-48.796,123.89 c-8.871,39.817-5.235,75.799,0.516,102.605c5.127-24.894,13.094-51.038,25.275-77.428 C1490.358,2789.671,1502.817,2783.933,1521.022,2734.785z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174578134130006962620000003159698654952700307_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.7561,
    y1: 2999.1172,
    x2: 64.2079,
    y2: 3387.0322,
    gradientTransform: "matrix(0.9542 -0.2992 0.2992 0.9542 -14.04 -148.0025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174578134130006962620000003159698654952700307_)"
    },
    d: "M1429.579,2443.107 c-20.282,93.107-63.494,235.277-162.499,383.677c-73.296,109.863-153.816,188.137-216.974,240.434 c-4.492,1.343-12.151,2.991-21.54,1.84c-6.977-0.857-12.51-2.965-16.231-4.74c4.351-26.248,13.526-65.023,35.285-106.904 c39.816-76.636,75.271-74.175,115.263-141.813c29.282-49.526,38.804-102.137,57.847-207.36 c14.704-81.25,14.714-100.67,34.848-123.968C1296.286,2437.17,1372.725,2436.638,1429.579,2443.107z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116914102829491242690000010470934429208999590_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.6584,
    y1: 2988.1997,
    x2: 43.8687,
    y2: 3368.0579,
    gradientTransform: "matrix(0.9542 -0.2992 0.2992 0.9542 -14.04 -148.0025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116914102829491242690000010470934429208999590_)"
    },
    d: "M1062.885,2974.745 c14.21-22.426,39.422-45.78,89.153-91.849c51.397-47.611,49.421-39.004,59.538-53.073 c45.292-62.992,20.767-130.301,31.964-211.531c6.248-45.32,26.259-104.542,84.52-170.879 c-27.304,5.035-53.447,15.862-72.482,36.861c-23.371,25.784-21.648,51.033-34.848,123.968 c-19.043,105.223-28.564,157.834-57.847,207.36c-39.991,67.638-75.446,65.176-115.263,141.813 c-21.759,41.88-30.934,80.656-35.285,106.904c3.72,1.775,9.254,3.884,16.231,4.74c5.533,0.678,10.441,0.375,14.479-0.255 C1039.761,3015.552,1055.676,2986.122,1062.885,2974.745z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M1484.336,1838.072c0,0,16.661,124.048-114.049,211.509l139.087,33.178 c0,0,44.517-83.24,12.288-221.119L1484.336,1838.072z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113341463540225328560000017544802724865025167_",
    gradientUnits: "userSpaceOnUse",
    x1: -1722.5764,
    y1: 2122.2544,
    x2: -1730.7964,
    y2: 2023.6134,
    gradientTransform: "matrix(-0.9986 0.0537 0.0537 0.9986 -504.5519 -55.8024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113341463540225328560000017544802724865025167_)"
    },
    d: "M1353.182,1956.076 c6.831-13.453,9.648-13.374,11.325-20.475c3.823-16.182-6.047-36.734-14.417-37.02c-5.397-0.184-5.843,8.205-17.266,21.28 c-13.994,16.016-22.486,13.915-30.721,27.818c-1.927,3.252-10.596,17.891-5.265,28.817c6.804,13.943,33.631,16.152,44.844,5.396 C1347.002,1976.792,1344.768,1972.65,1353.182,1956.076z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088812774358119586450000011882196523458121624_",
    gradientUnits: "userSpaceOnUse",
    x1: 1345.7528,
    y1: 1879.2473,
    x2: 1372.8362,
    y2: 2285.4944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088812774358119586450000011882196523458121624_)"
    },
    d: "M1333.072,1970.593 c0,0,4.791,25.569,1.381,46.358c-3.083,18.789-37.889,38.307-44.56,43.905c-6.671,5.596,17.694,11.67,40.045,8.744 c22.35-2.925,83.547-22.507,92.846-33.421c9.301-10.914-10.828-5.536-27.755-7.603s-33.087-30.436-33.581-44.915 C1360.955,1969.18,1333.072,1970.593,1333.072,1970.593z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044144486454312828500000003701304781300225925_",
    gradientUnits: "userSpaceOnUse",
    x1: 4134.8125,
    y1: 2681.2124,
    x2: 4212.3389,
    y2: 2762.9294,
    gradientTransform: "matrix(0.966 -0.2584 0.2584 0.966 -3411.8352 402.9503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044144486454312828500000003701304781300225925_)"
    },
    d: "M1340.361,1989.676 c0,0,17.11,7.513,32.265-4.605c13.569-10.851-6.607-44.184-20.41-44.61c-4.605-0.142-11.326,3.157-15.295,7.984 c-2.344,2.851-2.483,4.751-6.404,9.335c-3.614,4.227-5.205,4.609-5.754,6.661c-0.688,2.567,0.493,6.858,9.784,14.236 c-4.629-0.854-8.622,0.367-10.167,3.065c-0.246,0.431-0.759,1.776-0.606,3.165 C1324.33,1989.937,1330.901,1992.266,1340.361,1989.676z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010310549423492581930000001894327688900073606_",
    gradientUnits: "userSpaceOnUse",
    x1: -1927.1832,
    y1: 980.8014,
    x2: -1960.9089,
    y2: 1213.3319,
    gradientTransform: "matrix(-1 0 0 1 -318.9724 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010310549423492581930000001894327688900073606_)"
    },
    d: "M1716.389,1900.742 c0,0,10.362-1.444,7.132-21.234c-2.533-15.513-0.615-20.73,3.047-17.98c3.661,2.75,4.179,11.715,4.179,11.715 s13.357-11.392,18.857-26.321c5.5-14.928,9.036-2.357,10.214,5.107c1.179,7.464-7.856,30.642-12.964,34.964 c-5.107,4.321-12.571,23.366-12.571,23.366L1716.389,1900.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1743.999,1906.044c-11.787-8.256-23.575-16.509-35.363-24.766 c-14.343,88.168-46.944,122.77-74.635,137.907c-66.802,36.514-126.423-28.555-254.287-2.001 c-35.235,7.317-96.653,20.948-130.708,71.143c-8.952,13.194-12.137,23.185-27.002,117.838 c-19.001,120.992-19.677,142.108-16.998,168.159c4.902,47.677,7.874,76.569,29.857,102.141 c58.372,67.906,182.442,32.893,197.997,28.285c28.736-8.511,73.398-21.741,91.142-59.713c8.349-17.865,7.462-34.199-5.37-99.535 c-25.418-129.427-28.665-137.802-21.57-151.976c23.944-47.83,99.812-20.461,163.902-64.94 C1698.438,2102.581,1740.677,2045.908,1743.999,1906.044z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116193108990471498540000010672928036137454263_",
    gradientUnits: "userSpaceOnUse",
    x1: -1887.5892,
    y1: 2068.1636,
    x2: -1787.0194,
    y2: 2591.9663,
    gradientTransform: "matrix(-1 0 0 1 -318.9724 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#F36F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC444"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000116193108990471498540000010672928036137454263_)"
    },
    d: "M1374.719,2487.465 c12.51-25.658-4.303-49.303,14.142-80.141c23.507-39.304,65.8-25.959,81.714-55c27.216-49.665-79.91-118.93-58.143-197.998 c10.393-37.751,46.683-65.075,76.999-75.427c67.304-22.982,111.328,35.602,174.428,17.285 c14.955-4.343,32.12-13.338,49.481-32.006c-15.345,32.374-34.403,51.934-52.375,64.407 c-64.09,44.479-139.958,17.11-163.902,64.94c-7.095,14.173-3.847,22.549,21.57,151.976c12.832,65.336,13.72,81.67,5.37,99.535 c-17.744,37.972-62.406,51.203-91.142,59.713c-8.515,2.523-49.551,14.122-94.52,12.997 C1358.403,2509.597,1369.2,2498.785,1374.719,2487.465z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.a71f606aa0d0a11b8468ebc4a7b9f8de.svg";
export { ForwardRef as ReactComponent };